// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Inbox Detail Page Styles */
.inbox-detail-page {
  min-height: 100vh;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
}

.inbox-detail-container {
  max-width: 800px;
  margin: 0 auto;
  padding: 100px 20px 40px;
}

.inbox-detail-nav {
  margin-bottom: 24px;
}

.back-button {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 18px;
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  color: #475569;
  text-decoration: none;
  font-size: 0.95rem;
  font-weight: 500;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.back-button:hover {
  background: #f8fafc;
  border-color: #22c55e;
  color: #22c55e;
}

.back-arrow {
  font-size: 1.1rem;
}

/* Message Card */
.inbox-detail-card {
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

.inbox-detail-header {
  padding: 28px 32px;
  border-bottom: 1px solid #f1f5f9;
}

.inbox-detail-title {
  font-size: 1.75rem;
  font-weight: 700;
  color: #1e293b;
  margin: 0 0 16px 0;
  line-height: 1.3;
}

.inbox-detail-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  color: #64748b;
  font-size: 0.9rem;
}

.inbox-detail-sender {
  display: flex;
  align-items: center;
  gap: 4px;
}

.inbox-detail-sender strong {
  color: #1e293b;
}

.inbox-detail-date {
  color: #94a3b8;
}

/* Content */
.inbox-detail-content {
  padding: 32px;
}

.inbox-detail-description {
  font-size: 1.05rem;
  line-height: 1.8;
  color: #334155;
  margin: 0;
  white-space: pre-wrap;
  word-break: break-word;
}

.inbox-detail-no-content {
  font-size: 1rem;
  color: #94a3b8;
  font-style: italic;
  margin: 0;
}

/* Actions */
.inbox-detail-actions {
  padding: 24px 32px;
  background: #f8fafc;
  border-top: 1px solid #f1f5f9;
}

.view-pdf-button {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 14px 28px;
  background: linear-gradient(135deg, #22c55e 0%, #16a34a 100%);
  color: white;
  text-decoration: none;
  border-radius: 10px;
  font-size: 1rem;
  font-weight: 600;
  transition: all 0.2s ease;
  box-shadow: 0 4px 12px rgba(34, 197, 94, 0.25);
}

.view-pdf-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(34, 197, 94, 0.35);
}

.pdf-icon {
  width: 20px;
  height: 20px;
}

/* Error State */
.inbox-detail-error {
  text-align: center;
  padding: 60px 40px;
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}

.inbox-detail-error .error-icon {
  width: 60px;
  height: 60px;
  margin: 0 auto 20px;
  background: #fef2f2;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  font-weight: 700;
  color: #ef4444;
}

.inbox-detail-error h2 {
  color: #1e293b;
  margin-bottom: 8px;
}

.inbox-detail-error p {
  color: #64748b;
  margin-bottom: 24px;
}

.inbox-detail-error .back-link {
  display: inline-flex;
  padding: 12px 24px;
  background: #22c55e;
  color: white;
  text-decoration: none;
  border-radius: 8px;
  font-weight: 500;
  transition: all 0.2s ease;
}

.inbox-detail-error .back-link:hover {
  background: #16a34a;
}

/* Responsive */
@media (max-width: 640px) {
  .inbox-detail-container {
    padding: 90px 16px 32px;
  }

  .inbox-detail-header {
    padding: 20px 20px;
  }

  .inbox-detail-title {
    font-size: 1.35rem;
  }

  .inbox-detail-meta {
    flex-direction: column;
    gap: 8px;
  }

  .inbox-detail-content {
    padding: 24px 20px;
  }

  .inbox-detail-description {
    font-size: 1rem;
  }

  .inbox-detail-actions {
    padding: 20px;
  }

  .view-pdf-button {
    width: 100%;
    justify-content: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/InboxDetailPage.css"],"names":[],"mappings":"AAAA,6BAA6B;AAC7B;EACE,iBAAiB;EACjB,6DAA6D;AAC/D;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,YAAY;AACZ;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,SAAS;AACX;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;AACF","sourcesContent":["/* Inbox Detail Page Styles */\n.inbox-detail-page {\n  min-height: 100vh;\n  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);\n}\n\n.inbox-detail-container {\n  max-width: 800px;\n  margin: 0 auto;\n  padding: 100px 20px 40px;\n}\n\n.inbox-detail-nav {\n  margin-bottom: 24px;\n}\n\n.back-button {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 18px;\n  background: white;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  color: #475569;\n  text-decoration: none;\n  font-size: 0.95rem;\n  font-weight: 500;\n  transition: all 0.2s ease;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.back-button:hover {\n  background: #f8fafc;\n  border-color: #22c55e;\n  color: #22c55e;\n}\n\n.back-arrow {\n  font-size: 1.1rem;\n}\n\n/* Message Card */\n.inbox-detail-card {\n  background: white;\n  border-radius: 16px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);\n  overflow: hidden;\n}\n\n.inbox-detail-header {\n  padding: 28px 32px;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.inbox-detail-title {\n  font-size: 1.75rem;\n  font-weight: 700;\n  color: #1e293b;\n  margin: 0 0 16px 0;\n  line-height: 1.3;\n}\n\n.inbox-detail-meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 20px;\n  color: #64748b;\n  font-size: 0.9rem;\n}\n\n.inbox-detail-sender {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.inbox-detail-sender strong {\n  color: #1e293b;\n}\n\n.inbox-detail-date {\n  color: #94a3b8;\n}\n\n/* Content */\n.inbox-detail-content {\n  padding: 32px;\n}\n\n.inbox-detail-description {\n  font-size: 1.05rem;\n  line-height: 1.8;\n  color: #334155;\n  margin: 0;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n.inbox-detail-no-content {\n  font-size: 1rem;\n  color: #94a3b8;\n  font-style: italic;\n  margin: 0;\n}\n\n/* Actions */\n.inbox-detail-actions {\n  padding: 24px 32px;\n  background: #f8fafc;\n  border-top: 1px solid #f1f5f9;\n}\n\n.view-pdf-button {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  padding: 14px 28px;\n  background: linear-gradient(135deg, #22c55e 0%, #16a34a 100%);\n  color: white;\n  text-decoration: none;\n  border-radius: 10px;\n  font-size: 1rem;\n  font-weight: 600;\n  transition: all 0.2s ease;\n  box-shadow: 0 4px 12px rgba(34, 197, 94, 0.25);\n}\n\n.view-pdf-button:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(34, 197, 94, 0.35);\n}\n\n.pdf-icon {\n  width: 20px;\n  height: 20px;\n}\n\n/* Error State */\n.inbox-detail-error {\n  text-align: center;\n  padding: 60px 40px;\n  background: white;\n  border-radius: 16px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);\n}\n\n.inbox-detail-error .error-icon {\n  width: 60px;\n  height: 60px;\n  margin: 0 auto 20px;\n  background: #fef2f2;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #ef4444;\n}\n\n.inbox-detail-error h2 {\n  color: #1e293b;\n  margin-bottom: 8px;\n}\n\n.inbox-detail-error p {\n  color: #64748b;\n  margin-bottom: 24px;\n}\n\n.inbox-detail-error .back-link {\n  display: inline-flex;\n  padding: 12px 24px;\n  background: #22c55e;\n  color: white;\n  text-decoration: none;\n  border-radius: 8px;\n  font-weight: 500;\n  transition: all 0.2s ease;\n}\n\n.inbox-detail-error .back-link:hover {\n  background: #16a34a;\n}\n\n/* Responsive */\n@media (max-width: 640px) {\n  .inbox-detail-container {\n    padding: 90px 16px 32px;\n  }\n\n  .inbox-detail-header {\n    padding: 20px 20px;\n  }\n\n  .inbox-detail-title {\n    font-size: 1.35rem;\n  }\n\n  .inbox-detail-meta {\n    flex-direction: column;\n    gap: 8px;\n  }\n\n  .inbox-detail-content {\n    padding: 24px 20px;\n  }\n\n  .inbox-detail-description {\n    font-size: 1rem;\n  }\n\n  .inbox-detail-actions {\n    padding: 20px;\n  }\n\n  .view-pdf-button {\n    width: 100%;\n    justify-content: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
